<template>
  <div
    class="seminar-registration-event-fi"
    @click="$emit('clicked')"
  >
    <div class="seminar-registration-event-fi__top">
      <icon-fi
        :icon="active ? 'radio-btn-on' : 'radio-btn-off'"
        class="seminar-registration-event-fi__toggle"
      />
      <div class="seminar-registration-event-fi__date">
        {{ event.end.day ? `${event.start.day} - ${event.end.day}` : event.start.day }}
      </div>
      <div
        :class="[
          'seminar-registration-event-fi__status',
          `seminar-registration-event-fi__status--${eventStatus}`,
        ]"
      />
    </div>

    <div class="seminar-registration-event-fi__content">
      <div class="seminar-registration-event-fi__events">
        <div
          v-for="(element, idx) in events"
          :key="idx"
          class="seminar-registration-event-fi__event"
        >
          <div
            v-if="element.title"
            class="seminar-registration-event-fi__event__title"
          >
            {{ element.title }}
          </div>

          <div
            v-for="followEvent in element.followEvents"
            :key="followEvent.id"
            class="seminar-registration-event-fi__event__follow-event"
          >
            <div class="seminar-registration-event-fi__event__follow-event__item">
              <icon-fi
                icon="calendar"
                class="seminar-registration-event-fi__event__follow-event__icon"
              />
              {{ followEvent.start.day }}
            </div>
            <div class="seminar-registration-event-fi__event__follow-event__item">
              <icon-fi
                icon="clock"
                class="seminar-registration-event-fi__event__follow-event__icon"
              />
              {{ followEvent.start.time }} - {{ followEvent.end.time }}
            </div>
            <div
              class="seminar-registration-event-fi__event__follow-event__item seminar-registration-event-fi__event__follow-event__item--full"
            >
              <icon-fi
                icon="map-pin"
                class="seminar-registration-event-fi__event__follow-event__icon"
              />
              {{ followEvent.location.city }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { IconFi } from 'atoms';
import { computed } from 'vue';

defineOptions({
  name: 'SeminarRegistrationEventFi',
});

defineEmits<{
  clicked: [value: void];
}>();

const props = defineProps<{
  event: any;
  active: boolean;
}>();

const events = computed(() => {
  if (props.event.seminars) {
    const inningEvents: any = [];

    props.event.seminars.forEach((seminar: any) => {
      const event = { title: seminar.title, followEvents: [] };
      const seminarEvents: any = [];
      seminar.events?.forEach((event: any) => {
        seminarEvents.push(...event.followEvents);
      });
      event.followEvents = seminarEvents;
      inningEvents.push(event);
    });

    return inningEvents;
  }

  return [props.event];
});

const eventStatus = computed(() => {
  if (props.event.actualParticipants === props.event.maxParticipants) {
    return 'full';
  }

  if ((100 * props.event.actualParticipants) / props.event.maxParticipants > 25) {
    return 'partly';
  }

  return 'free';
});
</script>

<style scoped src="./seminar-registration-event-fi" />
